import React, { useCallback } from 'react'
import { css } from '@emotion/react'
import { useDispatch, useSelector } from 'react-redux'
import { button } from '@groovehq/internal-design-system/lib/styles/elements'
import { selectNeedsPushPermission } from 'selectors/webPush'
import { doUpdateAudioNotificationsFromUI } from 'ducks/chat/actions/notifications'
import { selectIsMatrixClientReady } from 'ducks/chat/selectors/client'

const containerStyle = theme => css`
  padding: 10px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.09);
  && h1 {
    margin-top: 0;
    font-size: ${theme.fontSize.base};
    font-weight: ${theme.fontWeight.medium};
  }
  button {
    font-weight: ${theme.fontWeight.medium};
  }
`

const NotificationsPermissions = () => {
  const clientReady = useSelector(selectIsMatrixClientReady)
  const needsPushPermission = useSelector(selectNeedsPushPermission)
  const dispatch = useDispatch()
  const onEnable = useCallback(
    () => {
      dispatch(doUpdateAudioNotificationsFromUI(true))
    },
    [dispatch]
  )

  if (!clientReady || !needsPushPermission) return null
  return (
    <div css={containerStyle}>
      <h1>Enable notifications</h1>
      <p>Never miss a message with notifications enabled.</p>
      <button type="button" css={[button.styles.link]} onClick={onEnable}>
        Enable now
      </button>
    </div>
  )
}

export default NotificationsPermissions
